import { Actions, ofType, createEffect } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { withLatestFrom, switchMap, map, catchError, filter, mergeMap } from 'rxjs/operators';
import { SimpleResult } from '@app/common/models/simpleResult.model';
import { InitialMediaTipState, MediaTipState, selectmediatipState } from './state';
import { MediatipActionType, GetMediatipAction, MediatipErrorAction, GetMediatipActionDone, GetMediatipsAction, GetMediatipsActionDone, UpdateMediatipAction, UpdateMediatipActionDone, DeleteMediatipAction, DeleteMediatipActionDone,  InsertMediatipAction, InsertMediatipActionDone, GetMediatipBubDataAction, GetMediatipBubDataActionDone, GetSoMaContactsAction as GetLipoContactsAction, GetSoMaContactsActionDone, GetBubDataByEansAction, GetBubDataByEansActionDone } from './actions';
import { MediatipService } from '@app/common/services/mediatip.service';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { AuthService } from 'FoxxyLib';
import { GeneralResultEnum } from '@app/common/models';

import { IBubData, BubDataResult } from 'FoxxyInterfaces';
import { IMediatipSearchParameter, MediatipState } from '@app/common/models/mediatips.models';



@Injectable()
export class MediatipEffects {
  state$ : Observable<MediaTipState> = of(InitialMediaTipState);



  isManagerUser$ : Observable<boolean> = of(false);
  ismanager: boolean;
  getSoMAContacts$: any;
  getBubData$: any;
  getBubDataByEans$: any;
  updateMediatip$: any;
  insertMediatip$: any;
  getMediatip$: any;
  getMediatips$: any;
  deleteMediatip$: any;

  
  constructor(
    private store: Store<any>,
    private service: MediatipService,
    private authService: AuthService,
    private actions: Actions
    ) {

    this.state$ = this.store.pipe(select(selectmediatipState));
    this.isManagerUser$ = this.authService.claims$
    .pipe(
      filter(f => !!f.member_of),
      map(userInfo => environment.managers.some(x => userInfo.member_of.includes(x))));

      this.isManagerUser$.subscribe(m => this.ismanager = m);





 this.getMediatips$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetMediatipsAction>(MediatipActionType.GetMediatipsAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.service.getMediatips(<IMediatipSearchParameter>{ skip: action.payload.skip, take: action.payload.take,  userid: action.payload.userid, tryloadall: action.payload.allmediatips, sortoption: action.payload.sortoption, fromDate: action.payload.fromDate }).pipe(
        map(response => {

          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new GetMediatipsActionDone({ mediatips: response.data, isManager: this.ismanager });
          }

        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })
    )})


  this.getMediatip$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetMediatipAction>(MediatipActionType.GetMediatipAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.service.getMediatip(action.payload.id, this.ismanager).pipe(
        map(response => {
          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new GetMediatipActionDone({ mediatip: response.data });
          }
        }), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })
    )})



  this.insertMediatip$ = createEffect(() => { return  this.actions.pipe(
    ofType<InsertMediatipAction>(MediatipActionType.InsertMediatipAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.service.insertNewMediatip(action.payload.newmediatip).pipe(
        map(response => {
          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new InsertMediatipActionDone({ newmediatip: response.data, isManager: this.ismanager });
          }
        }
        )
      )), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
      })
      )})


  this.updateMediatip$ = createEffect(() => { return  this.actions.pipe(
    ofType<UpdateMediatipAction>(MediatipActionType.UpdateMediatipAction),
    withLatestFrom(this.state$),
    mergeMap(([action]) =>
      this.service.updateMediatip(action.payload.mediatip).pipe(
        map(response => {

          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new UpdateMediatipActionDone({ mediatip: response.data, isManager: this.ismanager, removefromStore: action.payload.removefromStore });
          }
        }
        )
      )), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
      })
      )})



  this.deleteMediatip$ = createEffect(() => { return  this.actions.pipe(
    ofType<DeleteMediatipAction>(MediatipActionType.DeleteMediatipAction),
    withLatestFrom(this.state$),
    switchMap(([action,]) =>
      this.service.deleteMediatip(action.payload.mediatipid).pipe(
        map(response => {
          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new DeleteMediatipActionDone({ mediatipid: response.data, isManager: this.ismanager });
          }
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })
    )})



  this.getBubDataByEans$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetBubDataByEansAction>(MediatipActionType.GetBubDataByEansAction),
    withLatestFrom(this.state$),
    mergeMap(([action]) =>
      this.service.getBubDataByEans(action.payload.eans).pipe(
        map(response => {
          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new GetBubDataByEansActionDone({ bubDataList: response.data });
          }
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })
    )})



  this.getBubData$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetMediatipBubDataAction>(MediatipActionType.GetMediatipBubDataAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.service.getBubDataByEan(action.payload.ean).pipe(
        map(response => {
          if (response.generalResult != GeneralResultEnum.Success) {
            return new MediatipErrorAction({ error: <SimpleResult>response });
          } else {
            return new GetMediatipBubDataActionDone({
              bubData: response.data == undefined ? <BubDataResult>{
                ean: action.payload.ean,
                bubData: <IBubData>{
                  ean: "",
                  warenGroup: "",
                  titel: "",
                  autor: "",
                  verlag: "",
                  preis: 0,
                  erscheinung: null,
                  kategorie: "",
                }
              } : <BubDataResult>{ ean: action.payload.ean, bubData: response.data }
            });
          }
        })
      )
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })
    )})



  this.getSoMAContacts$ = createEffect(() => { return  this.actions.pipe(
    ofType<GetLipoContactsAction>(MediatipActionType.GetSoMaContactsAction),
    withLatestFrom(this.state$),
    switchMap(([action]) =>
      this.service.getLiPoContacts().pipe(
        map(response => {
          return new GetSoMaContactsActionDone({
            somaContacts: response.data
          });
        }
        ))
    ), catchError((error, caught) => {
            this.store.dispatch(new MediatipErrorAction({ error: error }));
            return caught;
    })

    )})

  }
}
